import { createContext, useState } from "react";

export const RegenerateInvoicePdfActionContext = createContext<any>(null);

export function RegenerateInvoicePdfActionProvider({ children }: any) {
  const [showModal, setShowModal] = useState(false);
  const [invoiceId, setInvoiceId] = useState<number | null>(null);

  const value = {
    showModal,
    setShowModal,
    invoiceId,
    setInvoiceId,
  };

  return (
    <RegenerateInvoicePdfActionContext.Provider value={value}>
      {children}
    </RegenerateInvoicePdfActionContext.Provider>
  );
}

export default RegenerateInvoicePdfActionProvider;